<template>
  <div class="login-main">
    <img class="bg" src="../assets/img/login-bg.jpg" >
    <div class="content">
      <div class="box">
        <el-form :model="form" label-width="1rem" v-if="type == 'password'">
          <el-form-item label="账号">
            <el-input v-model="form.username" placeholder="账号"></el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input type="password" v-model="form.userPassword" placeholder="密码"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button @click="login">登录</el-button>
          </el-form-item>
        </el-form>
        <div class="scan" v-else>
          <div class="title">系统登录</div>
          <div class="msg" v-if="succeed||lose" style="cursor: pointer" @click="createCode">重新扫码</div>
          <div class="msg" v-else>{{sec}}s后失效</div>
          <div class="qrcode-box">
            <canvas ref="qrcode" class="qrcode" id="qrcode"></canvas>
            <div class="shadow" v-if="succeed||lose">
              <div v-if="succeed">
                <i class="el-icon-success" style="font-size: 0.6rem;color: #67C23A"></i>
                <div style="color: white;margin-top: 0.1rem">扫码成功</div>
              </div>
              <div v-if="lose">
                <i class="el-icon-warning" style="font-size: 0.6rem;color: #e6a23c"></i>
                <div style="color: white;margin-top: 0.1rem">已失效</div>
              </div>
            </div>
          </div>
          <div class="text">OA扫码登录</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcode'

import { getPin, login, getUserInfo } from '@/api/user'
import { initWebSocket } from '@/utils/websocket'

const sec = 60
export default {
  data () {
    return {
      type: 'scan',
      sec: 60,
      form: {
        clientType: 'app',
        username: 'hb666',
        userPassword: '66666666'
      },
      lose: false,
      succeed: false
    }
  },
  computed: {},
  mounted () {
    if (this.$route.query.type) {
      this.type = this.$route.query.type
    }
    if (this.type === 'scan') {
      this.createCode()
    }
  },
  methods: {
    createCode () {
      this.websocket && this.websocket.close()
      this.succeed = false
      this.lose = false
      this.sec = sec
      getPin({ clientType: 'app', url: 'views/feedMaterial/index' }).then(res => {
        if (res.code === 200) {
          // 生产二维码
          const width = document.getElementById('qrcode').offsetWidth
          const height = document.getElementById('qrcode').offsetHeight
          const canvas = this.$refs.qrcode
          const pin = res.data
          QRCode.toCanvas(canvas, 'yslogin==' + res.data, {
            width,
            height,
            margin: 0
          }, error => {
            if (error) console.error(error)
          })

          // 初始化socket监听是否扫码成功
          this.websocket = initWebSocket('loginapp', pin, (e) => {
            let data = JSON.parse(e.data)
            if (data.code === 1) {
              localStorage.setItem('token', data.token)
              // 获取用户信息
              getUserInfo().then(res => {
                localStorage.setItem('userInfo', JSON.stringify(res.data.userInfo))
                this.$router.push({
                  path: '/index'
                })
              })
            } else if (data.code === -1) {
              this.succeed = true
              window.clearInterval(this.timer)
            }
          })

          // 定时器倒计时
          this.timer = setInterval(() => {
            this.sec--
            if (this.sec <= 0) {
              this.lose = true
              this.websocket && this.websocket.close()
              window.clearInterval(this.timer)
            }
          }, 1000)
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    login () {
      login(this.form).then(res => {
        if (res.code === 200) {
          // 获取用户信息
          getUserInfo().then(res => {
            localStorage.setItem('userInfo', JSON.stringify(res.data.userInfo))
            this.$router.push({
              path: '/index'
            })
          })
        } else {
          this.$message.warning(res.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-main {
  position: relative;
  height: 100vh;
  background-color: #2E295F;
  .bg{
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .content{
    position: absolute;
    height: 100%;
    width: 50%;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .box{
      background-color: #fff;
      width: 4.12rem;
      height: 4.3rem;
      border-radius: 0.1rem;
      .scan{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .title{
          line-height: 0.39rem;
          color: rgba(155,155,155,1);
          font-size: 0.28rem;
        }
        .msg{
          color: #7b8a8c;
          margin-bottom: 0.1rem;
          margin-top: 0.32rem;
        }
        .qrcode-box{
          position: relative;
          width: 1.76rem;
          height: 1.76rem;
          margin-bottom: 0.25rem;
          .qrcode{
            width: 1.76rem;
            height: 1.76rem;
            background-color: rgba(0,0,0,0.1);
          }
          .shadow{
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,0.8);
            position: absolute;
            top:0;
            left: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
          }
        }
        .text{
          color: rgba(15,64,245,1);
          font-size: 0.2rem;
        }
      }
    }
  }
}
</style>
